import { Injectable } from '@angular/core';

import { Field, FieldKinds, Form } from '@site-mate/dashpivot-shared-library';

import { ChartSettings } from 'app/shared/model/charts/chart-settings.model';
import { ChartUtilsService } from 'app/shared/service/chart-utils.service';

@Injectable()
export class BarChartDataParser {
  constructor(private readonly chartUtilsService: ChartUtilsService) {}

  // TODO: this should be pulled to a web worker
  public parseForms(forms: Form[], chart: ChartSettings, dateRange) {
    const data = this.chartUtilsService.populateDates(chart.dateUnit, dateRange);

    forms.forEach((form) => {
      const date = this.chartUtilsService.getFormDate(chart, form);
      const table = form.items.find((item) => item._id === chart.itemId);

      if (!table) {
        return;
      }

      if (table.kind === FieldKinds.Table) {
        this.pullDataFromDefaultTable(table, form, chart, data, date);
      }

      if (table.kind === FieldKinds.PrefilledTable) {
        this.pullDataFromPrefilledTable(table, form, chart, data, date);
      }
    });

    const result = Object.values(data);
    return result;
  }

  private pullDataFromPrefilledTable(table: Field, form: any, chart: ChartSettings, data: any, date: string) {
    const groupName = this.chartUtilsService.getGroupNameForRow(form, chart, table, { columns: [] });
    let group = data[date].series.find((series) => series.name === groupName);

    if (!group) {
      group = {
        name: groupName,
        value: 0,
      };
      data[date].series.push(group);
    }

    table.rows.find((row) =>
      row.columns.find((column) => {
        if (column._id === chart.columnId) {
          group.value += Number.isNaN(+column.value) ? 0 : +column.value;
          return true;
        }

        return false;
      }),
    );
  }

  private pullDataFromDefaultTable(table: Field, form: any, chart: ChartSettings, data: any, date: string) {
    table.rows.forEach((row) => {
      const groupName = this.chartUtilsService.getGroupNameForRow(form, chart, table, row);
      let group = data[date].series.find((series) => series.name === groupName);

      if (!group) {
        group = {
          name: groupName,
          value: 0,
        };
        data[date].series.push(group);
      }

      group.value += this.chartUtilsService.extractFieldValue(row, chart);
    });
  }
}
